import { type RadiusLegacyKeys, radiusLegacy } from "./legacy/token-radius";

export const radiusTokens = {
  br0: 0, // Full-width elements, content containers
  br1: 8, // Text fields, cards, image containers
  br2: 16, // Content containers
  br3: 24, // Modals and overlays
  br6: 48, // Marketing containers
  brFull: 999, // Buttons, avatars, pills
} as const;

export type RadiusTokensKeys = keyof typeof radiusTokens;

// Combined export for backward compatibility
export const radius: typeof radiusTokens & typeof radiusLegacy = {
  ...radiusLegacy,
  ...radiusTokens,
};

export type RadiusKeys = RadiusTokensKeys | RadiusLegacyKeys;
